import WhatsAppInbox from './components/WhatsAppInbox';
import PublicAnalytics from './components/PublicAnalytics';
import BroadcastAdmin from './components/BroadcastAdmin';
import SourceReview from './components/SourceReview';
import AnnouncementAdmin from './components/AnnouncementAdmin';
import PhysicalLibrary from './components/PhysicalLibrary';
import MembershipGate from './components/MembershipGate';
import MembershipAdmin from './components/MembershipAdmin';
import routeMetadata from "./data/routeMetadata.json";
import publicSearchRoutes from "./data/publicSearchRoutes.json";
import brandMedia from "./data/brandMedia.json";
import { LocaleProvider, useLocale } from "./context/LocaleContext";
import React from "react";
import RouteFocus from './components/RouteFocus';
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import { AuthProvider, useAuth } from "./context/AuthContext";
import Layout from "./components/Layout";
import HomePage from "./components/HomePage";
import Placeholder from "./components/Placeholder";
import ChatHistory from "./components/ChatHistory";
import ContentSection from "./components/ContentSection";
import { contentSections } from "./data/contentCatalog";
import LoginPage from "./components/LoginPage";
import WelcomePage from './components/WelcomePage';
import PasswordRecovery from './components/PasswordRecovery';
import AccountMethods from './components/AccountMethods';
import LearningHub,{MemberRequests} from './components/LearningHub';
import PersonalNotebook from './components/PersonalNotebook';
import {LearningDiscovery} from './components/LearningDiscovery';
import LearningAdmin from './components/LearningAdmin';
import ReadingSettings,{ReadingPreferences} from './components/ReadingSettings';
import AuthCallback from "./components/AuthCallback";
import DuaPage from "./components/DuaPage";
import ContactPage from "./components/ContactPage";
import LegalPage from "./components/LegalPage";
import MemberProfile from "./components/MemberProfile";
import { sideNav } from "./mock";
import {contentNavigationRoutes} from "./context/navigationStructure";

const QuranListen = React.lazy(() => import('./components/QuranListen'));

function VisitorOrMemberLayout(){
 const {user,loading}=useAuth(); const {pathname}=useLocation();
 if(!user&&pathname==='/')return <WelcomePage/>;
 if(loading)return <p role="status">Oturum kontrol ediliyor…</p>;
 return <MembershipGate><Layout/></MembershipGate>;
}

function MemberEntry() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/giris" replace />;
  return <MemberProfile />;
}

function RobotsPolicy() {
  const { t, locale } = useLocale();
  const { pathname } = useLocation();
  React.useEffect(() => {
    const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
    const entry = routeMetadata[path] || { title: "Sayfa Bulunamadı | Sayyâdî", description: "Aradığınız sayfa bulunamadı.", noindex: true };
    const canonical = "https://sayyadi.com.tr" + path;
    const title = entry.title.split(" | ").map(part => t(part)).join(" | ");
    document.title = title;
    function meta(attribute, key, content) {
      let tag = document.head.querySelector('meta[' + attribute + '="' + key + '"]');
      if (!tag) { tag = document.createElement("meta"); tag.setAttribute(attribute, key); document.head.appendChild(tag); }
      tag.content = content;
    }
    meta("name", "robots", publicSearchRoutes.includes(path) ? "index,follow" : "noindex,nofollow,noarchive");
    meta("name", "description", entry.description);
    meta("property", "og:title", title);
    meta("property", "og:description", entry.description);
    meta("property", "og:url", canonical);
    meta("property", "og:image", brandMedia.image);
    meta("property", "og:image:width", String(brandMedia.width));
    meta("property", "og:image:height", String(brandMedia.height));
    meta("property", "og:image:alt", brandMedia.alt);
    meta("name", "twitter:title", title);
    meta("name", "twitter:description", entry.description);
    meta("name", "twitter:image", brandMedia.image);
    meta("name", "twitter:image:alt", brandMedia.alt);
    let link = document.head.querySelector('link[rel="canonical"]');
    if (!link) { link = document.createElement("link"); link.rel = "canonical"; document.head.appendChild(link); }
    link.href = canonical;
  }, [pathname, locale, t]);
  return null;
}

function AppRoutes() {
  const location = useLocation();

    if (location.hash?.includes("session_id=") && location.pathname!=="/giris-yontemleri") {
    return <AuthCallback />;
  }

  const innerRoutes = contentNavigationRoutes([...sideNav, ...["/ilahiler", "/evrad-zikar", "/kasideler"].map(to => ({id: to, to}))])
    .map((item) => (
      <Route key={item.id} path={item.to} element={contentSections[item.to] ? <ContentSection path={item.to} /> : <Placeholder title={item.label} />} />
    ));

  return (
    <>
    <RobotsPolicy /><ReadingPreferences/>
    <Routes>
      <Route path="/giris" element={<LoginPage />} />
      <Route path="/sifremi-unuttum" element={<PasswordRecovery key="forgot"/>}/>
      <Route path="/sifre-yenile" element={<PasswordRecovery key="reset" reset/>}/>
      <Route path="/eposta-dogrula" element={<PasswordRecovery key="email" reset attach/>}/>
      <Route path="/giris-yontemleri" element={<AccountMethods/>}/>
      <Route path="/sanal-dergah" element={<MembershipGate><MemberEntry /></MembershipGate>} />
      <Route path="/yonetim/yayin" element={<MembershipGate><BroadcastAdmin/></MembershipGate>} />
      <Route path="/yonetim/whatsapp" element={<MembershipGate><WhatsAppInbox/></MembershipGate>}/>
      <Route path="/yonetim/ai-kaynaklar" element={<MembershipGate><SourceReview/></MembershipGate>} />
      <Route path="/yonetim/duyurular" element={<MembershipGate><AnnouncementAdmin/></MembershipGate>} />
      <Route path="/yonetim/icerikler" element={<MembershipGate><LearningAdmin/></MembershipGate>}/>
      <Route path="/yonetim" element={<MembershipGate><MembershipAdmin/></MembershipGate>} />
      {["/gizlilik", "/veri-silme", "/kullanim-kosullari"].map(path => <Route key={path} path={path} element={<LegalPage path={path} />} />)}
      <Route element={<VisitorOrMemberLayout/>}>
        <Route path="/" element={<HomePage />} />
        <Route path="/kuran-dinle" element={<React.Suspense fallback={<div role="status">…</div>}><QuranListen /></React.Suspense>} />
        <Route path="/notlarim" element={<PersonalNotebook/>}/><Route path="/konu-kesfi" element={<LearningDiscovery/>}/><Route path="/ders-paketleri" element={<LearningHub kind="course"/>}/>
        <Route path="/baslangic" element={<LearningHub/>}/>
        <Route path="/tarih-gelenek" element={<LearningHub kind="history"/>}/>
        <Route path="/kavramlar" element={<LearningHub kind="glossary"/>}/>
        <Route path="/hocaya-sor" element={<MemberRequests/>}/>
        <Route path="/erisim-ayarlari" element={<ReadingSettings/>}/>
        <Route path="/dergah-kutuphanesi" element={<PhysicalLibrary />} />
        {innerRoutes}
        <Route path="/sohbet" element={<ChatHistory newChat/>} />
        <Route path="/mahmut-efendim-ai" element={<ChatHistory newChat assistant/>} />
        <Route path="/dua-bagisi" element={<DuaPage />} />
        <Route path="/hakkimizda" element={<Placeholder title="Hakkımızda" paragraphs={["Sayyâdi; Mahmut Efendim sohbetlerini, dijital arşivi, İslâmî kütüphaneyi ve dervişin günlük yolculuğuna eşlik eden içerikleri bir araya getiren bir irfan ve araştırma platformudur. Amacımız kaynağı bulmak, içeriği korumak ve kullanıcıya anlaşılır biçimde sunmaktır.","Kütüphane, eser ve baskı bilgilerini keşfetmek içindir. Tam metin araştırması ise kitapların sayfa ve pasajlarına, sohbetlerin zamanlı transkriptlerine dayanır. Bu iki araştırma yolu aynı kaynak kimlikleriyle ilişkilendirilir.","Temel ilkemiz: Kanıt yoksa cevap yok. Bir cevabın hangi esere veya sohbete dayandığı gösterilmelidir. Kaynak, sayfa ya da zaman bilgisi doğrulanamıyorsa içerik kesin ve kaynaklı bir cevap olarak sunulmaz.","İlahiler, evrad, ezkâr ve kasideler; eser, metin, icra ve kayıt kaynaklarıyla birlikte düzenlenir. Kullanıcının kişisel kayıtları ve geçmiş sohbetleri hesabına aittir. İçeriklerin yayımlanması, kaynak doğrulaması ve ilgili erişim izinlerine bağlıdır."]} />} />
        <Route path="/kaynaklar" element={<Placeholder title="Kaynaklar" paragraphs={["Kitap kaynaklarında eser, müellif, baskı veya tercüme, cilt, dijital dosya ve pasaj birlikte izlenir. Basılı sayfa numarası ile PDF içindeki sayfa sırası ayrı tutulur. Farklı baskı ve tercümeler yalnız isim benzerliğine bakılarak aynı kayıt sayılmaz.","Video ve ses kaynaklarında sohbetin kimliği, kayıt adı, transkript pasajı ve başlangıç–bitiş zamanı birlikte gösterilmelidir. Bir sohbetin cevabına başka bir kaydın metni kaynak olarak karıştırılmaz.","OCR ve otomatik transkripsiyon, okunabilir bir taslak üretir. İşlemin tamamlanması metnin doğruluğunu kanıtlamaz. Kaynak eşlemesi, sayfa veya zaman bilgisi ve metin kalitesi ayrıca incelenir; orijinal materyal korunur.","Araştırma yaklaşımımızda HathiTrust’ın katalog ile tam metin ayrımı ve Europeana’nın metadata, filtre, medya ve koleksiyon ilişkileri örnek alınır. Bu yaklaşım, Sayyâdi arşivinin kendi eser ve sohbet kimlikleriyle uygulanır.","Kaynaklı cevap; kanıt pasajını ve dayandığı kaydı korumalıdır. Desteklenmeyen iddia eklenmez; çelişkili kaynaklar tek bir kesin hükme zorlanmaz. Yeterli kanıt bulunamadığında bunun açıkça belirtilmesi gerekir."]} />} />
        <Route path="/iletisim" element={<ContactPage />} />
        <Route path="*" element={<Placeholder title="Sayfa Bulunamadı" />} />
      </Route>
    </Routes>
    </>
  );
}

function App() {
  return (
    <LocaleProvider><div className="App">
      <BrowserRouter>
        <AuthProvider>
          <PublicAnalytics />
          <RouteFocus /><AppRoutes />
        </AuthProvider>
      </BrowserRouter>
      <Toaster position="top-center" />
    </div></LocaleProvider>
  );
}

export default App;

